 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML04_COPYRIGHT from '@/components/html/04_Copyright'
 import HTML03_TITLE_PAGE from '@/components/html/03_Title_Page'
 import HTML02_SERIES_PAGE from '@/components/html/02_Series_Page'
 import HTML05_THE_COLLECTED_WORKS_OF_F__A__HAY from '@/components/html/05_THE_COLLECTED_WORKS_OF_F__A__HAY'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_EDITORIAL_FOREWORD from '@/components/html/07_Editorial_Foreword'
 import HTML08_INTRODUCTION from '@/components/html/08_Introduction'
 import HTML09_PART_ONE__VIENNA_NEW_YORK_VIENNA from '@/components/html/09_PART_ONE__Vienna_New_York_Vienna'
 import HTML10_PART_TWO__LONDON from '@/components/html/10_PART_TWO__London'
 import HTML11_PLATES from '@/components/html/11_PLATES'
 import HTML12_PART_THREEA__PARTING_IN_THE_ROAD from '@/components/html/12_PART_THREEA__Parting_in_the_Road'
 import HTML13_PART_FOUR__CHICAGO_FREIBURG from '@/components/html/13_PART_FOUR__Chicago_Freiburg'
 import HTML14_PUBLICATIONS_AND_LETTERS_MENTION from '@/components/html/14_Publications_and_Letters_Mention'
 import HTML15_INDEX_OF_PERSONS_AND_PLACES from '@/components/html/15_Index_of_Persons_and_Places'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_Editorial_Foreword",
 			"name" : "html/07_Editorial_Foreword",
 			"component" : HTML07_EDITORIAL_FOREWORD
 		},
 		{
 			"path" : "/html/08_Introduction",
 			"name" : "html/08_Introduction",
 			"component" : HTML08_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js